import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './Testimonial.module.scss';

const Testimonial = ({ customer, location, content }) => {
  return (
    <div className={`${styles.container} col-md-4`}>
      <div className={styles.card}>
        <FontAwesomeIcon
          icon="quote-left"
          size="2x"
          className={styles['quotation-mark']}
        />

        <p className={styles.paragraph}>{content}</p>

        <div className={styles.author}>
          {customer}
          <br />
          {location}
        </div>
      </div>
    </div>
  );
};

Testimonial.propTypes = {
  customer: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default Testimonial;
